<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editForm" label-width="170px">
        <el-form-item class="addAdminForm" label="采购单位">
          <el-select v-model="editForm.purchasecompany" placeholder="请选择">
            <el-option
              v-for="item in PurchaseCompanyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="项目名称">
          <el-select v-model="editForm.projectcode" placeholder="请选择" class="select" @change="selectProject()" filterable>
            <el-option
              v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="物料名称" v-if="editForm.projectclassification == '产品'">
          <el-select v-model="editForm.bomsn" placeholder="请选择" class="select" @change="selectBom()" filterable>
            <el-option
              v-for="item in BomDanCaiList" :key="item.Materialcode" :label="item.Info" :value="item.Materialcode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="供应商">
          <el-select v-model="editForm.supplierid" placeholder="请选择" class="select" filterable>
            <el-option
              v-for="item in SupplierProfileList" :key="item.Id" :label="item.Suppliername" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="合同单价">
          <el-input v-model="editForm.contractunitprice" @input="processAmount()"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="合同数量">
          <el-input v-model="editForm.contractnum" @input="processAmount()"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="合同金额">
          <el-input v-model="editForm.contractamount" ></el-input>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="付款信息">
          <div class="productdata1">
            <div class="productdata2">
              付款条件:
              <el-input v-model="editFormsub.Paymentterms" style="width: 20%"></el-input>
              付款时间:
              <el-date-picker v-model="editFormsub.Paymenttime" type="date" value-format="yyyy-MM-dd" style="width: 20%"></el-date-picker>
              付款金额:
              <el-input v-model="editFormsub.Paymentamount" style="width: 15%"></el-input>
              <el-button type="text" @click="clickAddSubPayment()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <el-card v-for="item,index in editForm.SubPayment" :key="index">
            <li>付款条件：{{item.Paymentterms}}；付款时间：{{item.Paymenttime}}；付款金额：{{item.Paymentamount}}；
            <el-button type="text" @click="clickDeleteSubPayment(index)">删除</el-button>
            </li>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm" label="交货日期">
          <el-date-picker v-model="editForm.receivetime" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="editForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickSave">保存</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      PurchaseCompanyOptions:[],
      ProjectNameList:[],
      BomDanCaiList:[],
      SupplierProfileList:[],
      PaymentInfoList:[],
      editForm: {
        id: 0,
        purchasecompany: '',
        projectcode: '',
        projectclassification: '',
        projectname: '',
        bomsn: '',
        supplierid: '',
        contractunitprice: '0',
        contractamount: '0',
        contractnum: '0',
        SubPayment: [],
        receivetime: '',
        beizhu: '',
        attachment: ''
      },
      editFormsub: {
        Paymentterms: '',
        Paymenttime: '',
        Paymentamount: ''
      },
      suppliernameFirst: ''
    }
  },
  mounted () {
    this.PurchaseCompanyOptions = Vue.prototype.FunGetPurchaseCompany()
    this.apiGetErp6ProjectNameList()
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.purchasecompany = row.Purchasecompany
      this.editForm.projectcode = row.Projectcode
      this.editForm.projectclassification = row.Projectclassification
      this.editForm.projectname = row.Projectname
      this.editForm.bomsn = row.Bomsn
      this.editForm.contractunitprice = row.Contractunitprice
      this.editForm.contractamount = row.Contractamount
      this.editForm.contractnum = row.Contractnum
      this.editForm.SubPayment = row.Sublist
      this.editForm.receivetime = row.Receivetime
      this.editForm.beizhu = row.Beizhu
      this.editForm.attachment = row.Attachment
      this.$refs.MultiImgOrPdf.cleardata()
      this.suppliernameFirst = row.Suppliername

      this.apiGetErp6BomDanCaiList()
      this.apiGetErp6SupplierProfileListByCode(true);
    },
    processAmount (){
      var buf = Number(this.editForm.contractunitprice) * Number(this.editForm.contractnum)
      this.editForm.contractamount = this.pnum(buf)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    clickAddSubPayment () {
      if (this.editFormsub.Paymentterms.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入付款条件')
        return
      }
      if (this.editFormsub.Paymenttime.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入付款时间')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormsub.Paymentamount)) {
        Vue.prototype.FunAlertMsg('请输入付款金额')
        return
      }

      this.editForm.SubPayment.push({
        Paymentterms: this.editFormsub.Paymentterms,
        Paymenttime: this.editFormsub.Paymenttime,
        Paymentamount: parseFloat(this.editFormsub.Paymentamount)
      })
    },
    clickDeleteSubPayment (index) {
      var buflist = []
      for (var j = 0, len = this.editForm.SubPayment.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.editForm.SubPayment[j])
        }
      }
      this.editForm.SubPayment = buflist
    },
    clickReturn () {
      this.$emit('triggerFunc', '')
    },
    clickSave () {
      this.apiEditErp6PurchaseOrder()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.attachment = url
    },
    selectProject () {
      this.editForm.projectclassification = ''
      this.editForm.projectname = ''
      this.editForm.bomsn = ''
      this.BomDanCaiList = []
      this.apiGetErp6BomDanCaiList()

      this.editForm.supplierid = ''
      this.SupplierProfileList = []
      this.apiGetErp6SupplierProfileListByCode(false)
    },
    selectBom () {
      this.editForm.supplierid = ''
      this.SupplierProfileList = []
      this.apiGetErp6SupplierProfileListByCode(false)
    },
    //为下拉框获取数据源-项目名称
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ProjectNameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源--物料信息
    apiGetErp6BomDanCaiList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productcode: that.editForm.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6BomDanCaiList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.editForm.projectclassification = response.data.ProjectClassification
            that.editForm.projectname = response.data.ProjectName
            that.BomDanCaiList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源--供应商信息
    apiGetErp6SupplierProfileListByCode: function (isFirst) {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        projectcode: that.editForm.projectcode,
        bomsn: that.editForm.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SupplierProfileListByCode, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.SupplierProfileList = response.data.List
            if(isFirst){
              for (const cell of response.data.List) {
                console.log(cell);
                if(cell.Suppliername == that.suppliernameFirst){
                  that.editForm.supplierid = cell.Id
                }
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiEditErp6PurchaseOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        purchasecompany: that.editForm.purchasecompany,
        projectcode: that.editForm.projectcode,
        projectclassification: that.editForm.projectclassification,
        projectname: that.editForm.projectname,
        bomsn: that.editForm.bomsn,
        supplierid: that.editForm.supplierid,
        contractunitprice: that.editForm.contractunitprice,
        contractamount: that.editForm.contractamount,
        contractnum: that.editForm.contractnum,
        subpayment: JSON.stringify(that.editForm.SubPayment),
        receivetime: that.editForm.receivetime,
        beizhu: that.editForm.beizhu,
        attachment: that.editForm.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6PurchaseOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
